// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes Gradient{0%{background-position:100% 50%}100%{background-position:-100% 50%}}.gradient-animation{background:linear-gradient(90deg, #E5EEF5 10%, #BEDAF3 50%, #E5EEF5 90%);background-size:200%;animation:Gradient 2s linear infinite;position:relative}", ""]);
// Exports
module.exports = exports;
